"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRhumb = require("react-rhumb");

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _UnauthorizedPage = _interopRequireDefault(require("settings-ui-sdk/Auth/UnauthorizedPage"));

var SitemapsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SitemapsContainer, _PureComponent);

  function SitemapsContainer() {
    (0, _classCallCheck2.default)(this, SitemapsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SitemapsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(SitemapsContainer, [{
    key: "render",
    value: function render() {
      if (!this.props.hasSitemapsAccess) {
        return _react.default.createElement("div", {
          className: "sitemaps-unauthorized-page"
        }, _react.default.createElement(_reactRhumb.NavMarker, {
          name: "SITEMAPS_LOADED"
        }), _react.default.createElement(_UnauthorizedPage.default, {
          moduleName: "marketing.pages.sitemaps"
        }), ";");
      }

      return this.props.children;
    }
  }]);
  return SitemapsContainer;
}(_react.PureComponent);

SitemapsContainer.propTypes = {
  hasSitemapsAccess: _react.PropTypes.bool,
  children: _react.PropTypes.node
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasSitemapsAccess: (0, _selectors.getHasSitemapsAccess)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(SitemapsContainer);

exports.default = _default;
module.exports = exports.default;